<template>
    <div class="dashboard">
        <section
            class="summary-section"
            v-if="true"
        >
            <div class="summary-card card-solid-warning">
                <h3>Online Users</h3>
                <h2>0</h2>
            </div>

            <div class="summary-card card-solid-danger">
                <h3>Offline Users</h3>
                <h2>0</h2>
            </div>

            <div class="summary-card card-solid-secondary">
                <h3>Registered Users</h3>
                <h2>0</h2>
            </div>

            <div class="card-success">
                <h3>Upmood Population</h3>
                <load-on-scroll class="content">
                    <table>
                        <thead>
                            <tr>
                                <td>Country</td>
                                <td>Online</td>
                                <td>Offline</td>
                                <td>Average Emotion</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                @click="$router.push('/users')"
                                v-for="n in 100"
                                :key="n"
                            >
                                <td>Country name</td>
                                <td>9999</td>
                                <td>9999</td>
                                <td>9.9999</td>
                                <td> > </td>
                            </tr>
                        </tbody>
                    </table>
                </load-on-scroll>
            </div>
            <div class="card-success">
                <h3>Upmood Cancellation</h3>
                <load-on-scroll class="content">
                    <ul>
                        <li v-for="n in 100" :key="n">
                            <header>
                                <h4>User {{n}}</h4>
                                <p>2020-01-10 12:00:00</p>
                            </header>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minima, voluptates.</p>
                        </li>
                    </ul>
                </load-on-scroll>
            </div>
            <div class="card-success">
                <h3>Upmood Inquiries</h3>
                <load-on-scroll class="content">
                    <ul>
                        <li v-for="n in 100" :key="n">
                            <header>
                                <h4>User {{n}}</h4>
                                <p>2020-01-10 12:00:00</p>
                            </header>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minima, voluptates.</p>
                        </li>
                    </ul>
                </load-on-scroll>
            </div>
            <div class="card-success">
                <h3>Upmood Population</h3>
                <load-on-scroll class="content">
                    <ul>
                        <li v-for="n in 100" :key="n">
                            <header>
                                <h4>Report {{n}}</h4>
                                <p>2020-01-10 12:00:00</p>
                            </header>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minima, voluptates.</p>
                        </li>
                    </ul>
                </load-on-scroll>
            </div>
        </section>

        <loading v-else></loading>
    </div>
</template>

<script>
import LoadOnScroll from '@/components/layouts/LoadOnScroll.vue'
export default {
	components: {
		LoadOnScroll
	}
}
</script>

<style lang="scss" scoped>
.dashboard {
    max-width: 1080px;
    margin: 0 auto;

    .loading {
        transform: scale(2);
        margin: 20% auto;
    }

    .summary-section {
        @include flex-row(space-between, center);
        flex-wrap: wrap;
        padding: 30px;

        .summary-card {
            @include flex-column(center, center);
            width: 32%;
            height: 100px;
            color: #fff;

            h3 {
                margin-bottom: 10px;
            }
        }

        .card-success {
            width: 49%;
            margin-top: 30px;
            height: 300px;
            display: flex;
            flex-direction: column;

            h3 {
                border-bottom: 2px solid $light;
                padding-bottom: 15px;
            }

            .content {
                flex: 1 1 auto;

                table, ul {
                    width: 100%;
                }

                table {
                    border-collapse: collapse;

                    thead, td:last-child {
                        font-weight: 600;
                    }

                    td:not(:first-child) {
                        text-align: right;
                    }

                    tbody tr {
                        cursor: pointer;
                    }
                }

                td, li {
                    padding: 10px;
                }

                tr, li {
                    &:nth-child(odd) {
                        background-color: #fff;
                    }

                    &:nth-child(even) {
                        background-color: $light2;
                    }
                }

                header {
                    padding: 10px 0;
                    display: flex;

                    h4 {
                        flex: 1 1 auto;
                    }

                    p {
                        color: $dark;
                    }
                }
            }
        }
    }
}
</style>
